<template>
    <div>
        <template>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>产品介绍</p>
                <!--<p>News</p>-->
            </div>
        </div>
        </template>
        <div class="product_para clearfix">
            <div class="product_w_1440">
                <div class="product_intro">
                    <h4 class="title">总体介绍</h4>
                    <div class="blank_height"></div>
                    <div class="box clearfix">
                        <div class="video">
                            <img class="video_bg" src="@/assets/img/products/product_video_bg.png">
                            <div class="vd_box">
                                <video-player  class="video-player vjs-custom-skin"  ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
                            </div>

                        </div>
                        <div class="intro para">
                            <p>
                                近年来，随着互联网行业及技术的蓬勃发展，越来越多的传统商务交易开始由线下向线上转移，网上交易已成为当今社会发展的必然趋势。解决网上签约问题已成为用户的最迫切需求，“电子合同”，“电子签约”开始走进人们的视线。
                            </p>
                            <p>
                                大众一体化电子合同平台是一款基于《中华人民共和国电子签名法》而研发的具有完备法律效力的专业性SaaS平台，为用户提供在线电子签名、签章、合同管理及法律保障等一站式服务，凭借十余年签章产品研发经验及信息安全保护能力，使合同签署变得更加安全放心、简单高效。
                            </p>
                        </div>
                    </div>

                </div>
                <div class="blank_height"></div>
                <div class="product_func">
                    <div class="blank_height"></div>
                    <h4 class="func_title">主要功能</h4>
                    <p class="func_intro">大众签章致力于提升用户体验，对产品功能进行个性化设计，简洁直观，使用方便</p>
                    <div class="blank_height"></div>
                    <div class="func_modo clearfix">
                        <div class="text">
                            <div>
                                <h2>文件签署</h2>
                                <p>实现PC桌面端、网页端、移动端等多端的在线文件签署。多人会签、短信提醒、文件状态实时跟踪等功能满足更多用户业务需求。</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_1.png" alt="">
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_2.png" alt="">
                        </div>
                        <div class="text">
                            <div>
                                <h2>文件管理</h2>
                                <p>提供文件存储、分类、检索等功能，用户可快速精确定位文件，让文件管理更加高效。</p>
                            </div>
                        </div>
                        <div class="text">
                            <div>
                                <h2>模板管理</h2>
                                <p>提供大量合同模板供用户下载，用户也可上传自定义模板。让用户创建合同效率大大提高。</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_3.png" alt="">
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_4.png" alt="">
                        </div>
                        <div class="text">
                            <div>
                                <h2>文件在线查验</h2>
                                <p>上传已经签署了电子印章的文件，平台可对文件进行在线校验，返回验证结果。</p>
                            </div>
                        </div>
                        <div class="text">
                            <div>
                                <h2>账户权限管理</h2>
                                <p>企业账号与个人账号权限分级管理。通过账号级别控制用印权限，通过授权模式丰富用印业务。</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_5.png" alt="">
                        </div>
                        <div>
                            <img src="@/assets/img/products/product_fun_6.png" alt="">
                        </div>
                        <div class="text">
                            <div>
                                <h2>法律支持</h2>
                                <p>为用户提供完整的出证报告，让仲裁、鉴定等法律程序的处理更加简单清晰。</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blank_height1"></div>
                <div class="product_path">
                    <h1 class="func_title">签约流程</h1>
                    <p class="func_intro"></p>
                    <div class="path_box clearfix">
                        <div class="path_box_top clearfix">
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_register.png" alt="">
                                <p>注册登入</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/next_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_certificate.png" alt="">
                                <p>实名认证</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/next_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_launch.png" alt="">
                                <p>合同发起</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/next_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_mysign.png" alt="">
                                <p>我方签署</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/next_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_send.png" alt="">
                                <p>合同发送</p>
                            </div>
                        </div>
                        <div class="path_box_top clearfix">
                            <div class="path_block path_block_diff">
                                <img src="@/assets/img/products/icon_law3.png" alt="">
                                <p>法律服务</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/prev_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_verification.png" alt="">
                                <p>在线验证</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/prev_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_in_tray.png" alt="">
                                <p>合同归档</p>
                            </div>
                            <div class="direction_arrow">
                                <img src="@/assets/img/products/prev_arrow.png" alt="">
                            </div>
                            <div class="path_block">
                                <img src="@/assets/img/products/icon_other_sign.png" alt="">
                                <p>他方签署</p>
                            </div>
                            <div class="return_arrow">
                                <img src="@/assets/img/products/turn_arrow.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blank_height2"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "productCente",
        data(){
            return{
                screenWidth:'',
                screenHeight:'',
                playerOptions: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN', aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "",
                        src: 'https://aiosign.com/filePath1/group1/M00/00/07/rBABg17afsiAPZXrAIUZ2ArTiB8258.mp4'//url地址
                    }],
                    poster: "", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,//当前时间和持续时间的分隔符
                        durationDisplay: true,//显示持续时间
                        remainingTimeDisplay: false,//是否显示剩余时间功能
                        fullscreenToggle: true  //全屏按钮
                    }
                },
            }
        }

    }
</script>

<style scoped>
 .top_banner{
     background-image: url(~@/assets/img/banner/head_bar_product.png);
     background-size: 100% 100%;

 }
</style>